import MButton from "components/momentum/MButton";
import { Controller, useForm } from "react-hook-form";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Close } from "@mui/icons-material";
import { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { GridReadyEvent } from "ag-grid-community";
import { useAxios } from "myAxios";
import Reason from "./Reason";

const useStyles = makeStyles(() => ({
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 24px",
  },
  title: {
    fontSize: 20,
    fontFamily: "CiscoSansTT",
    color: "#394454",
    fontWeight: 350,
    display: "flex",
    alignItems: "center",
    letterSpacing: "0.16px",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "start",
    padding: "16px 20px",
  },
  mainWrapper: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 16,
  },
  text: {
    flexWrap: "wrap",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  radioGroupRoot: {
    display: "flex",
    flexDirection: "row",
    marginLeft: 3,
  },
}));

const BulkExceptionDialog: FC<{
  selected: string;
  gridEvent: GridReadyEvent | undefined;
  open: boolean;
  onClose: () => void;
  accountKeyArr: string[];
  selectedCallback: (data: string) => void;
}> = ({ selected, gridEvent, open, onClose, accountKeyArr, selectedCallback }) => {
  const classes = useStyles();
  const [updating, setUpdating] = useState(false);
  const axios = useAxios();
  const { handleSubmit, control, reset } = useForm();

  const onSubmit = async (submitData: { [key: string]: any }) => {
    setUpdating(true);
    const { reason } = submitData;
    if (!accountKeyArr?.length) {
      toast.error("Please select an account first!");
      return;
    }
    const toastId: React.ReactText = "";

    const postData = {
      coverageStatus: selected,
      accountKeys: accountKeyArr,
      reason: reason.trim(),
    };
    axios
      .put(`/api/dataservice/v1/accounts/account-engagement-model`, postData)
      .then((res) => {
        // console.log(res.data);
        const result = res.data;
        gridEvent?.api.forEachNode((n: any) => {
          if (accountKeyArr?.includes(n.data.accountKey)) {
            n.setDataValue("coverageStatus", result?.[n.data.accountKey]);
            n.setDataValue("aemExpReason", reason.trim());
          }
        });
        gridEvent?.api.redrawRows();
        selectedCallback("");
        reset();
        onClose();
        setUpdating(false);
        toast.dismiss(toastId);
      })
      .catch((err) => {
        setUpdating(false);
        toast.dismiss(toastId);
        toast.error(err?.response?.data?.message ?? `Fail to set account(s) as ${selected}`);
      });
  };

  const onError = (errors: { [key: string]: any }) => {
    if (Object.keys(errors)?.length) {
      toast.error(errors.reason.message, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      scroll={"paper"}
      fullWidth={true}
      disableEscapeKeyDown
      // hideBackdrop={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      disableAutoFocus={true}
      maxWidth={"xs"}
      onClose={onClose}
    >
      <div className={classes.titleContainer}>
        <div>
          <p className={classes.title}>Exception</p>
        </div>
        <IconButton
          size="small"
          onClick={() => onClose()}
        >
          <Close fontSize="small" />
        </IconButton>
      </div>
      <DialogContent
        dividers={true}
        className={classes.contentWrapper}
      >
        <img src="/portfolio/yellow-warning.svg" />
        <div className={classes.mainWrapper}>
          <p className={classes.text}>
            If you want to manually update the engagement model, please fill in the reason.{" "}
          </p>

          <form>
            <div className={classes.container}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Controller
                  control={control}
                  render={(props) => <Reason {...props} />}
                  name={"reason"}
                  defaultValue={null}
                  rules={{
                    required: {
                      message: "This field is required!",
                      value: true,
                    },
                    maxLength: { value: 50, message: "Maximum 50 characters" },
                  }}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                  marginTop: 16,
                }}
              >
                <MButton
                  type="reset"
                  buttonType="blue-reverse"
                  // buttonSize={20}
                  size="medium"
                  onClick={onClose}
                >
                  Cancel
                </MButton>
                <MButton
                  type="submit"
                  buttonType="blue"
                  // buttonSize={20}
                  size="medium"
                  disabled={updating}
                  onClick={handleSubmit((data) => onSubmit(data), onError)}
                >
                  Submit
                </MButton>
              </div>
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default BulkExceptionDialog;
